import React, { FC } from 'react';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import { productionBatchStatistics } from '@reducers/statistics';
import { getNCFileById } from '@reducers/manufacture';
import { close as clearTools, getTools } from '@reducers/clampingTools';
import { connect } from 'react-redux';
import { useBatchDetails } from '@v2/pages/common/hooks/useBatchDetails';
import { updateHeaderConfig } from '@reducers/details';
import { ImagesDocumentsContent } from '@v2/pages/nc-file/details/modules/nc-file/components/ImagesDocumentsContent';
import { DOCUMENT_ENTITY_TYPE } from '@components/imageHandling/common';
import { ReducerEntityWithLoadingState } from '@v2/pages/common/interfaces';
import { ProductionBatchStatistics } from '@interfaces/search';
import { View } from 'react-native';
import { DETAILS_DOCUMENTS_SCREENS_CONTAINER_STYLES } from '@v2/pages/common/constants/base.constants';

interface BatchDetailsJobDocumentsProps {
  batch: ReducerEntityWithLoadingState<ProductionBatchStatistics | null>;
}

const BatchDetailsJobDocumentsComponent: FC<BatchDetailsJobDocumentsProps> = ({
  productionBatchStatistics,
  getNCFileById,
  getTools,
  clearTools,
  updateHeaderConfig,
  batch,
}) => {
  const title = useTitle();

  useBatchDetails({
    clearTools,
    getNCFileById,
    getTools,
    productionBatchStatistics,
    updateHeaderConfig,
  });

  const jobId = batch?.data?.links?.[0]?.productionOperationId;

  return (
    <DetailsPageWrapper title={title.job}>
      {jobId && (
        <View style={DETAILS_DOCUMENTS_SCREENS_CONTAINER_STYLES}>
          <ImagesDocumentsContent documentRetrieveId={jobId} documentRetrieveKey={DOCUMENT_ENTITY_TYPE.ProductionOperation} />{' '}
        </View>
      )}
    </DetailsPageWrapper>
  );
};

const BatchDetailsJobsDocuments = connect(({ batch: { batch } }) => ({ batch }), {
  getNCFileById,
  productionBatchStatistics,
  getTools,
  clearTools,
  updateHeaderConfig,
})(BatchDetailsJobDocumentsComponent);

export { BatchDetailsJobsDocuments };
